<template>
  <div class="qingwu">
    <el-carousel :height="height">
      <el-carousel-item v-for="(v,k) in list" :key="k">
        <div
          class="shop_banner"
          :style="'background-position: center;background-size:cover;background-image:url('+v.advImg+');'"
          @click="goUrl(v)"
        >
          <div style="width:1200px;height:465px;display:block;"></div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    },
    height: {
      type: String,
      default: '465px'
    }
  },
  methods: {
    goUrl(e) {
      switch (parseInt(e.typekey)) {
        case 1: // 商品详情
          this.$router.push(`/goods/info/${e.typevalue}`)
          break
        case 2: // 文章单页
          this.$router.push(`/parse?key=${e.typevalue}`)
          break
        case 3: // url地址
          window.location.href = e.advUrl
          break
        case 4: // 分类
          this.$router.push(`/goods/list?name=${e.typevalue}`)
          break
        case 5: // 商品列表
          this.$router.push(`/goods/list?name=${e.typevalue}`)
          break
        case 6: // 售货机详情
          this.$router.push(`/machine/index?vemId=${e.typevalue}`)
          break
        case 7: // 积分商品
          this.$message.info('建设中')
          break
        case 8: // 优惠券领取
          this.$message.info('建设中')
          break
        case 9: // 客服电话
          window.location.href = 'tel://' + this.config.servicephone
          break
        case 10: // 无内容
          break
        case 11: // 售货机列表
          this.$router.push('/home/machine')
          break
        case 12: // 咖啡机列表
          this.$router.push('/home/coffee?type=2')
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.shop_banner {
  height: 100%;
  background-position: center;
}
</style>